/**
 * A function that ensures the first letter of a string is capitalized.
 */
export const capitalizeFirstLetter = (str: string): string => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};